import * as React from 'react'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'

interface IAbortButtonProps {
  label?: string
  disabled?: boolean
  onClick: () => void
}

const AbortButton: React.FC<IAbortButtonProps> = ({
  label,
  disabled,
  onClick,
}) => {
  const { t } = useTranslation()
  return (
    <Button
      size="small"
      variant="contained"
      color="secondary"
      disabled={disabled}
      startIcon={<CloseIcon />}
      onClick={onClick}
    >
      {label !== undefined ? label : t('buttons.abort')}
    </Button>
  )
}

export default AbortButton
